module.exports = __webpack_public_path__ + "static/media/product_sample_15.ef975ecc.jpg";